import { ReferencedEntry } from 'contentful';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentType, Navigation, NavigationType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { fetchEntries } from 'src/api/contentful/fetchEntries';
import { get } from 'src/utils/EntryUtil';
import { useSidebar } from '../SidebarContext/SidebarContext';

export function useContentfulNavigation(navigationType: NavigationType, include: number) {

  const { setIsLoading } = useSidebar();

  const [navigation, setNavigation] = useState<ReferencedEntry<Navigation>>();

  const { language } = useTranslation().i18n;

  const CONTENT_TYPE = ContentType.NAVIGATION;

  const fetchNavigation = () => {
    setIsLoading(true);

    fetchEntries<Navigation>(language, {
      contentType: CONTENT_TYPE,
      include,
      filters: { fields: { type: navigationType } },
    }).then(navigations =>
      setNavigation(get(navigations, 'items', [])[0] as ReferencedEntry<Navigation>)
    ).catch(err =>
      console.error(`Problem pulling ${CONTENT_TYPE} from Contentful`, err)
    );
  };

  useEffect(() => {
    fetchNavigation();
  }, [language, setNavigation]);

  return navigation;
}
